import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65f45410"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message-record-focus"
}

import {computed,ref,watch,onBeforeUnmount} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import request from '@/utils/request'
import store from '@/store'
import {focusedMessageId} from '@/utils/messageRecord'

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageRecordFocus',
  setup(__props) {

const route=useRoute(),router=useRouter(),id=computed(()=>focusedMessageId(route.query)),target=ref<any>(null),error=ref('')
let generation=0
watch([()=>route.fullPath,()=>store.getters.token],async()=>{
 const current=++generation;target.value=null;error.value='';if(!id.value)return
 try{const response=await request({url:`order/messages/${id.value}/target`,method:'GET'});if(current!==generation)return;if(response.data?.path!==route.path)throw new Error('该消息与当前功能不匹配，请从全站消息重新进入');target.value=response.data}
 catch(reason:any){if(current===generation)error.value=reason?.message || '关联记录暂不可用，请重新打开消息'}
},{immediate:true})
function clear(){const query={...route.query};for(const key of ['focusMessageId','focusRequestId','focusAuditId','focusAuditState'])delete query[key];void router.replace({path:route.path,query})}
onBeforeUnmount(()=>{generation++})

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_button = _resolveComponent("a-button")!

  return (id.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_alert, {
          type: error.value?'error':target.value?.completed?'warning':'info',
          "show-icon": ""
        }, {
          message: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.value || (target.value ? `已定位：${target.value.label || '关联记录'} · ${target.value.completed?'事件已处理或已流转，请核对当前状态':'请按记录当前状态处理'}` : '正在核对关联记录和访问权限…')), 1)
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_a_button, {
          size: "small",
          onClick: clear
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回正常列表")
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})